import { Factory } from 'rosie';

Factory.define('VgsAccountContent');
Factory.define('VgsAccountSecretContent');

Factory.define('VgsAccountContentWithDefaults')
  .extend('VgsAccountContent')
  .attr('vaultEnvironment', 'SANDBOX')
  .attr('vaultId', 'a-vault-id');
